import { ApiService, toData, toModel, toPaginatedModels } from '~/shared/api'
import type { Paginated } from '~/shared/interfaces'
import type { UniversityQueryParams } from '~/types/universities'
import type { ApiDataResponse } from '~/shared/types/api'
import { API_PREFIX } from '~/shared/const/request-services'
import { UniversityDirectionModel, UniversityModel } from '~/models/universities'

export type UniversityListParams = UniversityQueryParams & Record<string, string | number>

export class UniversitiesMainService extends ApiService {
  readonly urls = {
    list: `${API_PREFIX}/universities`,
    totalCount: `${API_PREFIX}/universities/total-count`,
    bySlug: (slug: string | number) => `${API_PREFIX}/universities/${slug}`,
    stream: (slug: string | number, id: string | number) =>
      `${API_PREFIX}/universities/${slug}/streams/${id}`,
  }

  getList(params: UniversityListParams = {}): Promise<Paginated<UniversityModel>> {
    return this.http
      .request({ url: this.urls.list, params })
      .then(toPaginatedModels(UniversityModel))
  }

  getTotalCount(): Promise<number> {
    return this.http
      .request<ApiDataResponse<{ count?: number }>>({ url: this.urls.totalCount })
      .then(toData())
      .then(data => Number(data?.count) || 0)
  }

  getBySlug(
    slug: string | number,
    params: Record<string, string | number> = {}
  ): Promise<UniversityModel> {
    return this.http.request({ url: this.urls.bySlug(slug), params }).then(toModel(UniversityModel))
  }

  getStream(
    slug: string | number,
    id: string | number,
    params: Record<string, string | number> = {}
  ): Promise<UniversityDirectionModel> {
    return this.http
      .request({ url: this.urls.stream(slug, id), params })
      .then(toModel(UniversityDirectionModel))
  }
}
